import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";
const token = getCookie("ColibriToken");
export const NotificationsService = {
  async getAllNotifications(url: string) {
    let response = await $axios
      .get(url || $api("notifications"), {
        headers: {
          
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async readSingleNotification( id: number) {
    let response = await $axios
      .put($api("get_notificationById", {  id }), {
        headers: {
          
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async readAllNotification(notification: any) {
    let response = await $axios
      .post($api("notifications_read_all"), notification, {
        headers: {
          
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
